import client from '@/api/client.js'
import store from "@/store";
export default {
    methods: {
        async getVehicleList() {
            var response = await client().get(store.state.apiRouteRoot + "UserController/getVehicleList", { meta: { clientApiMethod: 'getVehicleList' } })
            return response?.data;
        },
    }
}